export class ProductModel {
    id: string;
    shortName: string;
    longName: string;
    seatAssignmentPeriodActive: boolean;
    seatAssignmentBeginDate: Date;
    seatAssignmentEndDate: Date;
    enabled: boolean;
}
